module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-riben-h5.156f5008.jpg";